<header class="w-full bg-white py-2 container lg:hidden block">
  <div class="w-full flex items-center justify-between gap-2">
    <div (click)="setToggle()" class="bg-metal-50 flex items-center justify-between p-1 px-2 w-full rounded-lg">
      <div>
        <h4 class="text-base font-bold">
          {{autocompleteService._selectedItem().name}}
        </h4>
        <p *ngIf="datepickerService._startDate() && datepickerService._endDate()" class="text-muted text-sm">
          {{datepickerService._startDate()}}
          تا
          {{datepickerService._endDate()}}
        </p>
      </div>
      <i class="ico-Search font-bold text-xl"></i>
    </div>
    <div [class.hidden]="toggle" class="w-full h-[100vh] bg-white fixed top-0 right-0 z-[50]">
      <header>
        <div (click)="setToggle()" class="flex items-center gap-4 px-4 py-2 pb-0">
          <i class="ico-ArrowRight text-2xl"></i>
          <p class="text-lg">
            بازگشت
          </p>
        </div>
      </header>
      <div class="w-full h-[2px] my-2 bg-gray-200"></div>
      <div class="flex flex-col justify-between items-stretch gap-2 p-4">
        <div class="iho-autocomplete">
          <div ihoAutocomplete [isMobile]="true">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>
                {{searchBoxService.accommodation() == 'ecolodge' ? 'نام شهر یا کد آگهی' : 'مقصد یا هتل'}}
              </mat-label>
              <input matInput class="!font-bold" (click)="unfocus()" id="autocompleteinput-plp"
                [value]="autocompleteService._selectedItem().name !== undefined ? autocompleteService._selectedItem().name : ''">
              <mat-icon matPrefix>
                <i class="p-2 ico-Location text-xl text-gray-500"></i>
              </mat-icon>
            </mat-form-field>
          </div>
          <div [class.hidden]="autocompleteService._state() === 'hide' ? true : false"
            class="w-full h-[100vh] bg-white fixed top-0 right-0 z-[55] mobile">
            <iho-autocomplete />
          </div>
        </div>
        <div class="iho-datepicker mt-4">
          <div ihoDatepicker [isMobile]="true">
            <div class="flex justify-between gap-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>
                  تاریخ ورود
                </mat-label>
                <input matInput class="!font-bold" [value]="datepickerService._customStartDate()">
                <mat-icon matPrefix>
                  <i class="p-2 ico-Calender text-xl text-gray-500"></i>
                </mat-icon>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>
                  تاریخ خروج
                </mat-label>
                <input matInput class="!font-bold" [value]="datepickerService._customEndDate()">
                <mat-icon matPrefix>
                  <i class="p-2 ico-Calender text-xl text-gray-500"></i>
                </mat-icon>
              </mat-form-field>
            </div>
          </div>
          <div [class.hidden]="!datepickerService._state()" class="w-full h-[100vh] bg-white fixed top-0 right-0 z-10">
            <ng-container *ngComponentOutlet="csrStatus()"></ng-container>
          </div>
        </div>
        <button (click)="search(); setToggle()" class="w-full mt-2 py-2 font-bold bg-yellow-400 rounded-lg shadow-sm"
          color="accent">
          جستجو
        </button>
      </div>
    </div>
  </div>
</header>